export default __webpack_public_path__ + "static/media/severeSmile.6d4ab8ed.svg";